import { useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Menu, X, ArrowUpRight } from "lucide-react";
import { Logo } from "./Logo";
import { scrollToId } from "./SmoothScroll";

const LINKS = [
  { id: "services", label: "Services" },
  { id: "why", label: "Why us" },
  { id: "process", label: "How it works" },
];

export const Nav = () => {
  const [open, setOpen] = useState(false);
  const go = (id) => {
    setOpen(false);
    scrollToId(id);
  };
  return (
    <motion.header
      initial={{ y: -40, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, delay: 0.9, ease: [0.22, 1, 0.36, 1] }}
      className="fixed inset-x-0 top-0 z-50 border-b border-white/5 bg-[#090A0C]/70 backdrop-blur-xl"
    >
      <div className="mx-auto flex h-16 max-w-[1400px] items-center justify-between px-5 sm:px-8">
        <Link to="/" data-testid="nav-logo-link"><Logo /></Link>
        <nav className="hidden items-center gap-9 md:flex">
          {LINKS.map((l) => (
            <button key={l.id} onClick={() => go(l.id)} data-testid={`nav-${l.id}-link`}
              className="eyebrow transition-colors duration-300 hover:text-[var(--acid)]">
              {l.label}
            </button>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <Link to="/book" data-testid="nav-book-now-button"
            className="group hidden items-center gap-2 rounded-full bg-acid px-5 py-2.5 text-sm font-bold text-black transition-transform duration-300 hover:scale-[1.04] sm:flex">
            Book now <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:rotate-45" />
          </Link>
          <button onClick={() => setOpen(true)} className="p-2 text-zinc-100 md:hidden" data-testid="nav-mobile-menu-button" aria-label="Open menu">
            <Menu className="h-6 w-6" />
          </button>
        </div>
      </div>
      {open && (
        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}
          className="fixed inset-0 z-50 flex h-[100dvh] flex-col bg-[#090A0C] px-6 pb-10 pt-5" data-testid="mobile-menu">
          <div className="flex items-center justify-between">
            <Logo />
            <button onClick={() => setOpen(false)} className="p-2" data-testid="mobile-menu-close-button" aria-label="Close menu"><X className="h-6 w-6" /></button>
          </div>
          <div className="mt-16 flex flex-col gap-4">
            {LINKS.map((l, i) => (
              <motion.button key={l.id} initial={{ y: 30, opacity: 0 }} animate={{ y: 0, opacity: 1 }} transition={{ delay: 0.08 * i }}
                onClick={() => go(l.id)} data-testid={`mobile-nav-${l.id}-link`}
                className="text-left font-display text-6xl uppercase text-zinc-100">
                {l.label}
              </motion.button>
            ))}
          </div>
          <Link to="/book" data-testid="mobile-book-now-button" className="mt-auto rounded-full bg-acid py-4 text-center text-lg font-bold text-black">
            Book your clean
          </Link>
        </motion.div>
      )}
    </motion.header>
  );
};
